"use client";

import Image from "next/image";

// Paste the output from generateBlur.ts here
const LOGO_BLUR =
  "data:image/webp;base64,UklGRhwAAABXRUJQVlA4IBQAAAAwAQCdASoIAAQAAgA4AAYAAAMAuVORK5CYII=";

export default function Loading() {
  const logoUrl = `https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/${process.env.NEXT_PUBLIC_STORE_CODE}/logos/favicon.webp`;

  return (
    <div className="flex h-screen w-full items-center justify-center bg-white">
      {/* 
         REPLACED framer-motion with CSS animation to reduce initial JS payload by ~250KB.
         Loading screen should be as lightweight as possible.
      */}
      <div className="relative h-[130px] w-[130px] animate-pulse-scale">
        <Image
          src={logoUrl}
          alt="Loading..."
          fill
          sizes="130px"
          quality={85}
          priority
          placeholder="blur"
          blurDataURL={LOGO_BLUR}
          className="object-contain"
          onError={(e) => {
            (e.target as HTMLImageElement).src =
              "https://blr1.digitaloceanspaces.com/assetsvilva/vilvabusiness/website/common/otherallimages/empty-logowebp.webp";
          }}
        />
      </div>
      <style jsx global>{`
        @keyframes pulse-scale {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.1); opacity: 0.8; }
        }
        .animate-pulse-scale {
          animation: pulse-scale 1.5s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}